import { Link as LinkLi } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_DATE_FORMAT_WITH_TIME_24 } from 'globalconfig/constants/static';
import { objectIntoArray } from 'globalutils/fmUtils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useMemo, useState } from 'react';
import VideoJS from '../Vehicles/videoComponent';
import { columns, dataUsageColumns } from './config';
import DataUsageFilters from './DateUsageFilters';
import Filters from './Filters';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  fetchVideoUrl,
  callback,
  eventsData,
  dataUsageList,
  Styled,
  changeEventType,
  changeDataUsageFilter,
  changeDataUsageRequest,
  dataUsageRequest,
  i18n,
  history,
  pagination,
  changeRequest,
  request,
  paramsList,
  vehicleList,
  eventTypes: eventList,
  setPagination,
}) => {
  const eventTypes = useMemo(() => {
    return objectIntoArray(eventList);
  }, [eventList]);
  const [value, setValue] = useState(0);
  const [cameraModalList, setCameraModalList] = useState(null);

  const [values, setInitialValues] = useState({
    eventType: null,
    ...(paramsList ? paramsList : {}),
  });

  const [dataUsageValues, setDataUsageInitialValues] = useState({
    startDate: null,
    endDate: null,
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const generateRows = () => {
    return eventsData.data
      ? eventsData?.data?.map((el) => {
          return {
            ...el,
            camera_view: 360,
            date: moment.utc(parseFloat(el?.start_time))?.local().format(UI_DATE_FORMAT_WITH_TIME_24),
          };
        })
      : [];
  };

  const generateDataUsageRows = () => {
    return dataUsageList.data ? dataUsageList.data : [];
  };

  const information = i18n.t('common.tableEmptyMessage');

  const isEventOld = (eventDate, eventTime) => {
    const eventDateTime = moment(`${eventDate}T${eventTime}Z`);
    const sixMonthsAgo = moment().subtract(6, 'months');
    const isOld = eventDateTime.isBefore(sixMonthsAgo);
    return isOld;
  };

  const download = (urlVideo) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', urlVideo, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      const urlCreator = window.URL || window.webkitURL;
      const videoUrl = urlCreator.createObjectURL(this.response);
      const tag = document.createElement('a');
      tag.href = videoUrl;
      tag.target = '_blank';
      tag.download = 'file.mp4';
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    };
    xhr.onerror = () => {};
    xhr.send();
  };

  const tabValues = [
    {
      name: i18n.t('camera.tabs.events'),
      value: (
        <Styled.TableWrapper>
          <Filters
            fleetCompanyList={eventTypes}
            filterList={(data) => {
              changeEventType(data);
            }}
            vehicleList={vehicleList}
            handleReset={() => {
              changeEventType({ eventType: '' });
            }}
            values={values}
            setInitialValues={setInitialValues}
          />
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'vehicle', order: 'asc' }}
            title=""
            history={history}
            changeRequest={changeRequest}
            baseRequest={request}
            totalRecords={eventsData.total}
            columns={columns}
            data={generateRows()}
            emptyMessage={information}
            itemsPerPage={10}
            actions={[
              {
                icon: (row) => {
                  return (
                    <LinkLi
                      className="normalLink"
                      onClick={() => {
                        const callbackFunction = (videoUrl) => {
                          setCameraModalList({
                            header: '',
                            content: () => {
                              return (
                                <div>
                                  <VideoJS
                                    options={{
                                      autoplay: true,
                                      controls: true,
                                      responsive: true,
                                      cameraType: row?.camera_type || '',
                                      fluid: true,
                                      aspectRatio: '16:8',
                                      preload: 'auto',
                                      sources: [
                                        {
                                          src: videoUrl,
                                          type: 'video/mp4',
                                        },
                                      ],
                                    }}
                                  />
                                </div>
                              );
                            },
                          });
                        };
                        fetchVideoUrl({
                          apiId: 'videoUrlAPI',
                          data: {
                            clipID: row?.clip_id,
                            cameraType: row?.camera_type,
                            isOld: isEventOld(row?.date, row?.time),
                          },
                          callbackFirst: callbackFunction,
                          callbackSecond: callback,
                        });
                      }}
                    >
                      <Icon src={mediaUrls?.viewMoreIcon} tooltip={'View'} />
                    </LinkLi>
                  );
                },
              },
              {
                icon: (row) => {
                  return (
                    <LinkLi
                      className="normalLink"
                      onClick={() => {
                        fetchVideoUrl({
                          apiId: 'videoUrlAPI',
                          data: {
                            clipID: row?.clip_id,
                            cameraType: row?.camera_type,
                            isOld: isEventOld(row?.date, row?.time),
                          },
                          callbackFirst: download,
                          callbackSecond: callback,
                        });
                      }}
                    >
                      <Icon src={mediaUrls?.download} tooltip="Download" />
                    </LinkLi>
                  );
                },
              },
            ]}
            defaultSort={'full_name'}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      ),
    },
    {
      name: i18n.t('camera.tabs.dataUsage'),
      value: (
        <Styled.TableWrapper>
          <DataUsageFilters
            fleetCompanyList={eventTypes}
            filterList={(data) => {
              changeDataUsageFilter(data);
            }}
            handleReset={() => {
              changeDataUsageFilter({ startDate: '', endDate: '' });
            }}
            values={dataUsageValues}
            setInitialValues={setDataUsageInitialValues}
          />
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'vehicle', order: 'asc' }}
            totalRecords={dataUsageList.total}
            title=""
            changeRequest={changeDataUsageRequest}
            baseRequest={dataUsageRequest}
            columns={dataUsageColumns}
            data={generateDataUsageRows()}
            emptyMessage={information}
            itemsPerPage={10}
            actions={[]}
            defaultSort={'vehicle'}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
          {cameraModalList && (
            <Modal
              open={!!cameraModalList}
              setOpen={() => setCameraModalList(null)}
              data={cameraModalList}
              width={'760px'}
              withCloseIcon
              alignItemsLeft
              removeTopSpace
            />
          )}
        </Styled.TableWrapper>
      ),
    },
  ];
  return (
    <>
      <Styled.Wrapper>
        <Styled.BottomWrapper>
          <Tab data={tabValues} currentTab={value} onChange={handleChange} className="cameraTabs" />
        </Styled.BottomWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};
